import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DialogContent,
  Grid,
  Radio,
  DialogActions,
  Button,
  Dialog,
  styled,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import {
  scenarioaDataNext,
  uploadBaseLineData,
  closecreatedFolder,
  closeselectedFolder,
  uploadScenarioData,
  onInitGetScenarioNumber,
  closeModal,
} from "./../../Redux/Actions/InputData";
import NameTheScenario from "./NameTheScenario";
import ToastPopup from "../ToastPopup";
import * as actions from "./../../Redux/Actions/index";
import { SCENARIAO_BACK } from "./../../Redux/Actions/ActionType";

// import { scenarioaBack } from "./../../Redux/Actions/InputData";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function SelectDataUpload(props: any) {
  const dispatch: any = useDispatch();
  const [selectLine, setSelectLine] = React.useState("");
  const [isNext, setIsNext] = React.useState(false);

  const [inputScenarioNumber, setInputScenarioNumber] = React.useState("");
  const [inputScenarioName, setInputScenarioName] = React.useState("");
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId
  );
  const uploadFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedUploadFolderId
  );
  //Redux state
  const isScenarioaDataNext = useSelector(
    (state: any) => state.InputDataReducers.isScenarioaDataNext
  );
  const scenarioaBack = () => ({
    type: SCENARIAO_BACK,
  });

  const { isFolderSelected, folderSelectionMessage } = useSelector(
    (state: any) => state.InputDataReducers
  );

  const scenarioNumber = useSelector(
    (state: any) => state.InputDataReducers.scenarioNumber
  );

  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData
  );
  console.log(userData, "userData");

  const { isFolderCreated, folderCreationMessage, isScenarioCreated } =
    useSelector((state: any) => state.InputDataReducers);

  const handleChangeSelectLine = (e: any) => {
    e.preventDefault();
    const value = e.target.value;
    setSelectLine(value);
  };

  const handleNextBtnSelectLine = () => {
    if (selectLine === "scenario") {
      dispatch(scenarioaDataNext());
      dispatch(onInitGetScenarioNumber());
      // Add API Call for Scenario Number
    } else {
      dispatch(closeselectedFolder());
      dispatch(uploadBaseLineData());
    }
  };

  const BackToSelectDataUpload = () => {
    dispatch(scenarioaBack());
  };
  const closeFolderCreated = () => {
    dispatch(closecreatedFolder());
    dispatch(closeselectedFolder());
  };

  const handleInputScenarioNumber = (e: any) => {
    setInputScenarioNumber(e.target.value);
  };
  const handleInputScenarioName = (e: any) => {
    setInputScenarioName(e.target.value);
  };

  const handleGobackInputCreate = () => {
    dispatch(scenarioaBack());
  };

  const handleBack = (e: any) => {
    e.preventDefault();
    setIsNext(false);
    // setIsScenarioCreated(false);
    dispatch(closeModal());
  };

  const handleNextNameScenario = () => {
    const request = {
      scenario_id: scenarioNumber,
      folder_id: uploadFolderId, //props.inputFolderName,    //folderid
      scenario: inputScenarioName,
      filetype: 2, // 1- Baseline, 2- Scenario
      scenario_time: "",
      number: scenarioNumber, // take from the API
      createdBy: userData.userId,
    };
    dispatch(actions.onInitcreateNewScenario(request));
  };
  useEffect(() => {
    if (isScenarioCreated) {
      const data = {
        folder: uploadFolderId, //props.inputFolderName,
        time:
          new Date().getFullYear() +
          "-" +
          new Date().getMonth() +
          "-" +
          new Date().getDate(),
        scenario: inputScenarioName,
        number: inputScenarioNumber,
        type: selectLine,
        createdBy: userData.userId,
      };
      dispatch(uploadScenarioData(data));
    }
  }, [isScenarioCreated]);

  return (
    <>
      {isScenarioaDataNext && !isScenarioCreated && (
        <NameTheScenario
          isOpen={isScenarioaDataNext}
          BackToSelectDataUpload={BackToSelectDataUpload}
          handleNextNameScenario={handleNextNameScenario}
          selectLine={selectLine}
          inputScenarioNumber={inputScenarioNumber}
          inputScenarioName={inputScenarioName}
          handleInputScenarioNumber={handleInputScenarioNumber}
          handleInputScenarioName={handleInputScenarioName}
        />
      )}
      {!isScenarioCreated && (
        <BootstrapDialog
          onClose={closeFolderCreated}
          aria-labelledby="customized-dialog-title"
          open={props.isOpen}
        >
          <div className="modal-header">
            <Grid container spacing={1}>
              <Grid item xs={10} md={10} lg={10}>
                <h3>{"Select data to upload"}</h3>
                <p className="sub-title-text">
                  {"Get started with optimisation."}
                </p>
              </Grid>
              <Grid item xs={2} md={2} lg={2}>
                <CancelIcon
                  className="cancel-icon"
                  onClick={closeFolderCreated}
                />
              </Grid>
            </Grid>
          </div>
          <DialogContent className="modal-body">
            <div
              className={
                selectLine === "base" ? "master-check-selected" : "master-check"
              }
            >
              <Grid container spacing={1}>
                <Grid item xs={10} md={10} lg={10}>
                  <Radio
                    checked={selectLine === "base"}
                    onChange={handleChangeSelectLine}
                    value="base"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "base" }}
                  />

                  <label>Baseline data</label>
                </Grid>
                <Grid item xs={2} md={2} lg={2}>
                  <InfoIcon className="info-Icon" />
                </Grid>
              </Grid>
            </div>
            <div
              className={
                selectLine === "scenario"
                  ? "input-check-selected"
                  : "input-check"
              }
            >
              <Grid container spacing={1}>
                <Grid item xs={10} md={10} lg={10}>
                  <Radio
                    checked={selectLine === "scenario"}
                    onChange={handleChangeSelectLine}
                    value="scenario"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "scenario" }}
                  />
                  <label>Scenario Data</label>
                </Grid>
                <Grid item xs={2} md={2} lg={2}>
                  <InfoIcon className="info-Icon" />
                </Grid>
              </Grid>
            </div>
            <div className="note-area">
              <div className="note">
                <InfoIcon />
                <span>Note</span>
              </div>
              <ul className="ul-style">
                {folderCreationMessage && <li>{folderCreationMessage}</li>}
                <li className="li-baseline">
                  These files will be upload to the folder name{" "}
                  {props.inputFolderName}
                </li>
                <li>
                  Baseline data exists, you can override by uploading a new one.
                </li>
              </ul>
            </div>
          </DialogContent>
          {/* Toast popup */}
          {isFolderCreated && !isFolderSelected && (
            <ToastPopup message={folderCreationMessage} type="success" />
          )}
          {isFolderSelected && (
            <ToastPopup message={"Folder Selected"} type="success" />
          )}
          <DialogActions>
            <div className="modal-action">
              <Button
                variant="outlined"
                className="cancel"
                onClick={handleBack}
              >
                Go back
              </Button>
              <Button
                variant="contained"
                className={
                  selectLine === "" || selectLine === undefined
                    ? "disabled-proc-btn"
                    : "Next"
                }
                onClick={handleNextBtnSelectLine}
                // disabled={selectLine === ""}
              >
                Next
              </Button>
            </div>
          </DialogActions>
        </BootstrapDialog>
      )}
    </>
  );
}

export default SelectDataUpload;
